import React from 'react'
import LoginForm from './components/LoginForm'
import './style.css'

class LoginContainer extends React.Component {


  componentDidMount() {
    const rememberMe = localStorage.getItem("rememberMe")

    localStorage.clear()

    if (rememberMe) {
      localStorage.rememberMe = rememberMe
    }
  }

  render () {
    return (
      <div className="login-body">
        <div id="LoginContainer">
          <h2>
            PTOR | Publication Tracking and Online Resources
          </h2>

          <LoginForm {...this.props.routerProps}/>
        </div>
      </div>
    )
  }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/routes/login/LoginContainer.js